import { observer } from "mobx-react-lite";
import { HasLicensePermissions } from '../../../State/EvidenceDB/LicensePermissions';
import { AnalyticsTrafficData, AnalyticsTrafficDataFromDatabase, ClarityAnalyticsMessage, GoogleAnalyticsAnalyticsMessage } from './AnalyticsTrafficData';
import { UUID } from '../../../State/EvidenceDB/DatabaseTypes';
import classNames from "./AnalyticsTrafficView.module.css"

const ClarityMessageView = ({networkEvent, decodedPayload}: ClarityAnalyticsMessage) => {
	const {envelope, timestamp, ...rest} = decodedPayload;
	if (Object.keys(rest).length === 0) return null;
	const {pageNum, url = networkEvent.tab.url, sequence} = envelope;
	return (
		<section key={`clarity-data-for-${networkEvent.eventIndex}`}>
			{ sequence === 1 ? (
					<h2>Clarity {url} (page {pageNum})</h2>
				) : null
			}
			<h3>Clarity Message {sequence} at {new Date(timestamp).toISOString()}</h3>
			<details>
				<summary>envelope</summary>
				<div>Sent to {networkEvent.destination.url}</div>
				<pre>{JSON.stringify(envelope, undefined, 2)}</pre>
			</details>
			{
				Object.entries(rest).map( ([eventName, eventList]) => (
					<details key={eventName} open={eventName === 'click'}>
						<summary>{eventList.length} {eventName} {eventList.length === 1 ? `event` : `events`}</summary>
						{eventList.map( (event, index) => (
							<pre key={index}>{
								JSON.stringify(event, undefined, 2)	
							}</pre>
						))}
						{/* <pre>{JSON.stringify(eventList, undefined, 2)}</pre> */}
					</details>
				))
			}
		</section>
	);
}

export const UrlAnalyticsParametersView = ({type, networkEvent, urlSearchParams}: GoogleAnalyticsAnalyticsMessage) => {
	const eventType = type === "google-analytics" ?
		(urlSearchParams["t"]) : undefined;
	const pageName = type === "google-analytics" ? urlSearchParams["dt"] : undefined;
	const isPageType = type === "google-analytics" && eventType === "pageview";
	const pageUrl = urlSearchParams["dl"];
	return (
		<section key={`UrlAnalyticsParametersView-${networkEvent.eventIndex}`} >
			{ (eventType != null && isPageType) ? (
					<h2>Page ({type}): {pageName}</h2>
				) : (
					<h3>Event ({type}): {eventType ?? "unknown event"}</h3>
				)
			}
			{ pageUrl == null ? null : (
				<div style={{fontFamily: 'monospace', fontWeight: 'bold'}}>{pageUrl}</div>
			)}
			<pre>{
				Object.entries(urlSearchParams)
					.map( ([fieldName, fieldValue]) =>
						`${fieldName}: ${fieldValue}\n`
					).join("")
			}</pre>
		</section>
	)
}

export const TaxActGaRecordView = ({postTextEvents}: GoogleAnalyticsAnalyticsMessage) => {
	return (<>{(postTextEvents ?? [])
		.reverse() // short newest on top
		.map( (record, index) => {
		const eventTime = record["epn.event_time"];
		const key = eventTime != null && eventTime.length > 6 ? eventTime : `${index}`;
		const step = record["ep.app_step_data_layer"] ?? "";
		const action = record["ep.action"] ?? "";
		const label = record["ep.label"] ?? "";
		const event = record["en"] ?? "";
		//const eventDataLayer = record["ep.event_data_layer"] ?? "";
		return (
			<section className={classNames.TaxActGaRecord} key={key} >
				{ step.length === 0 ? null : (
					<div className={classNames.AnalyticsField}><div className={classNames.label}>Step</div>: <div className={classNames.value}>{step}</div></div>
				)}
				{ action.length === 0 ? null : (
					<div className={classNames.AnalyticsField}><div className={classNames.label}>Action</div>: <div className={classNames.value}>{action}</div></div>
				)}
				{ label.length === 0 ? null : (
					<div className={classNames.AnalyticsField}><div className={classNames.label}>Label</div>: <div className={classNames.value}>{label}</div></div>
				)}
				{ event.length === 0 ? null : (
					<div className={classNames.AnalyticsField}><div className={classNames.label}>Event</div>: <div className={classNames.value}>{event}</div></div>
				)}
				{/* { eventDataLayer.length === 0 ? null : (
					<div className={classNames.AnalyticsField}><div className={classNames.label}>Meta</div>: <div className={classNames.value}>{eventDataLayer}</div></div>
				)} */}
			</section>
		);
	})}</>)
};


export const AnalyticsReportView = observer( ({
	analyticsTrafficData,
	// ...rest
}: {
	analyticsTrafficData: AnalyticsTrafficData;
} & HasLicensePermissions) => {
	// const {licensePermissions} = rest;	
	// const filteredSummary = summary.filter( s => licensePermissions.mayGenerateIpReportsAt(s) )
	// if (filteredSummary.length === 0 && summary.length > 0) {
	// 	return (<LicenseRequiredView />)
	// }



	return (<>
		<h1>Data Decoded from Analytics Messages</h1>
		{ analyticsTrafficData.analyticsMessages.map( (e) => {
			const {eventIndex} = e.networkEvent;
			const key = `${e.type}-${eventIndex}`;
			switch (e.type) {
				case 'clarity':
					return (<ClarityMessageView key={key} {...e} />);
				case 'google-analytics':
					if (e.networkEvent.tab.url.startsWith("https://www.taxact.com/") && e.postTextEvents != null) {
						return <TaxActGaRecordView key={key} {...e} />;
					} else {
						// Hack for current use
						return (<UrlAnalyticsParametersView key={key} {...e} />);
//						return null;
					}
				default:
					return null;
			}
		})}
	</>);
});

export const AnalyticsReportFromDatabaseView = ({
	recordingUuid, ...rest
}: {
	recordingUuid: UUID
} & HasLicensePermissions) => {
	const analyticsTrafficData = AnalyticsTrafficDataFromDatabase.forRecordingUuid(recordingUuid);
	if (analyticsTrafficData != null) {
		return (<AnalyticsReportView {...{analyticsTrafficData, ...rest}}/>);
	}
}
